import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LoadingCover } from 'components';
import ProtectedRoute from 'components/Route/ProtectedRoute';
import { setRedirectPath } from 'models/user';
import { Suspense, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import routes from './config';
// Separate component to handle redirects inside router context
const RedirectHandler = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const redirectPath = useSelector((state) => state.user.redirectPath);
    useEffect(() => {
        if (redirectPath) {
            navigate(redirectPath, { replace: true });
            // Clear the redirect path after navigation to prevent redirect loops
            dispatch(setRedirectPath(null));
        }
    }, [redirectPath, navigate, dispatch]);
    return null;
};
const AppRoutes = () => {
    const isAuthenticated = useSelector((state) => state.user.isAuthenticated);
    const isApplicationLoading = useSelector((state) => state.user.isApplicationLoading);
    return (_jsx(LoadingCover, { full: true, isLoading: isApplicationLoading, children: _jsxs(Suspense, { fallback: _jsx(LoadingCover, { full: true, isLoading: true }), children: [_jsx(RedirectHandler, {}), _jsxs(Routes, { children: [routes.map(({ path, component: Component, isPrivate }) => isPrivate ? (_jsx(Route, { element: _jsx(ProtectedRoute, { isAuthenticated: isAuthenticated }), children: _jsx(Route, { path: path, element: _jsx(Component, {}) }) }, path)) : (_jsx(Route, { path: path, element: _jsx(Component, {}) }, path))), _jsx(Route, { path: "*", element: _jsx(Navigate, { to: "/", replace: true }) })] })] }) }));
};
export default AppRoutes;
